export const is_custom_email = (email) => {
  const value = email;
  if (
    /^([\w.-]+)@(\[(\d{1,3}\.){3}|(?!hotmail|gmail|yahoo|protonmail|titan|zoho|outlook|icloud|aol|gmx|yandex|mail|tutanota)(([a-zA-Z\d-]+\.)+))([a-zA-Z]{2,4}|\d{1,3})(\]?)$/.test(
      value
    )
  ) {
    return true;
  } else {
    return false;
  }
};
